import {
  ChangeDetectionStrategy,
  Component,
  Input,
  SimpleChanges
} from '@angular/core';
import { isSameDay } from 'date-fns';
import { AvtaleResponse } from 'src/app/services/avtale/avtale.types';
import {
  PrisDager,
  Priser,
  Prisomraade
} from 'src/app/services/spot/spot.types';
import { hasChanged } from 'src/app/utils/change-utils';
import { getHourList } from 'src/app/utils/date-utils';

@Component({
  selector: 'app-hour-spot-table',
  templateUrl: './hour-spot-table.component.html',
  styleUrls: ['./hour-spot-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HourSpotTableComponent {
  @Input() selectedDate: Date;
  @Input() dayPrices: PrisDager[];
  @Input() selectedArea: Prisomraade;
  @Input() avtaler: AvtaleResponse;

  tableData: {
    hourText: string;
    price: number;
    isHighest: boolean;
    isLowest: boolean;
  }[];
  averagePrice: number;
  paaslagList: { paaslag: number; active: boolean; }[];
  hours: number[] = getHourList();

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.dayPrices?.length > 0 &&
      this.selectedDate &&
      hasChanged([
        changes?.selectedArea,
        changes?.selectedDate,
        changes?.dayPrices,
        changes?.avtaler
      ])
    ) {
      this.hours = getHourList(this.selectedDate);
      if (hasChanged([changes?.avtaler])) {
        this.paaslagList =
          this.avtaler?.avtaler
            .filter((x) => x.prisomrade === this.selectedArea.omraade)
            .filter((x) => x.produktgruppe === 'Spotpris')
            .map((x) => x.paaslagOre)
            .filter(
              (value, index, listOfPaaslag) =>
                listOfPaaslag.indexOf(value) === index
            )
            .map((x) => ({ paaslag: x, active: false })) || [];
      }
      this.getTableData();
    }
  }

  getTableData() {
    const dayPricesForOmraade: Priser[] =
      this.dayPrices
        .find((x) => x.omrade === this.selectedArea.omraade)
        .dager.find((x) => isSameDay(new Date(x.dato), this.selectedDate))
        ?.priser || [];
    const highest = [...dayPricesForOmraade].sort((a, b) => b.pris - a.pris)[0];
    const lowest = [...dayPricesForOmraade].sort((a, b) => a.pris - b.pris)[0];
    this.tableData = dayPricesForOmraade.map((hourPrice, i) => {
      return {
        hourText: `${(this.hours[i]).toString().padStart(2, '0')}:00 - ${hourPrice.timenr === 24
          ? '00'
          : (this.hours[i + 1] ? this.hours[i + 1] : 24).toString().padStart(2, '0')
          }:00`,
        price:
          hourPrice.pris +
          (this.paaslagList.find((x) => x.active)?.paaslag || 0),
        isHighest: hourPrice.tidspunkt === highest.tidspunkt,
        isLowest: hourPrice.tidspunkt === lowest.tidspunkt
      };
    });
    this.averagePrice =
      this.tableData.reduce((acc, curr) => acc + curr.price, 0) /
      this.tableData.length;
  }

  toggleShowPaaslag(paaslag: { paaslag: number; active: boolean; }) {
    this.paaslagList = this.paaslagList.map((x) => {
      if (x.paaslag === paaslag.paaslag) {
        return { ...x, active: !x.active };
      }
      return { ...x, active: false };
    });
    this.getTableData();
  }
}
